const actionTypes = require('constants/actionTypes');
const apiURLBuilder = require('core/apiURLBuilder');
const { APIGet } = require('utilities/APIRequestHelper');


const requestPredictionDetailSuccess = (response) => {
    return {
        type: actionTypes.BROKER_IA_GET_PREDICTION_DETAIL_SUCCESS,
        payload: {
            data: response
        }
    };
}

const requestPredictionDetailFetching = () => {
    return {
        type: actionTypes.BROKER_IA_GET_PREDICTION_DETAIL_FETCHING
    };
}

const requestPredictionDetailFailure = (response) => {
    return {
        type: actionTypes.BROKER_IA_GET_PREDICTION_DETAIL_FAILURE,
        payload: {
            data: response
        }
    };
}

const getPredictionDetailAction = (dispatch, isin, miccode, currency, predictionDetail = 'brokerIAPredictionDetail') => {
    const requestData = {
        isin,
        miccode,
        currency
    };

    dispatch(requestPredictionDetailFetching());

    return APIGet(dispatch, apiURLBuilder.getURL(predictionDetail, requestData))
        .then(function(response) {
            dispatch(requestPredictionDetailSuccess(response));
        })
        .catch(function(response) {
            dispatch(requestPredictionDetailFailure(response));
        }
    );
    
};

const getPredictionDetail = (isin, miccode, currency) => dispatch => getPredictionDetailAction(dispatch, isin, miccode, currency);

module.exports = {
    getPredictionDetail,
    getPredictionDetailAction
};
